import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get permission
export const getRole = createAsyncThunk("role/getRole", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getRole({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all permission
export const getAllRole = createAsyncThunk("role/getAllRole", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllRole();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("role/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("role/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("role/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageRole({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
export const getRoleById = createAsyncThunk("role/getRoleById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getRoleById(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create permission
export const createRole = createAsyncThunk("role/createRole", async (param, { rejectWithValue }) => {
  const { name, permissions, isActive } = param;
  try {
    const body = JSON.stringify({ name, isActive, permissions });
    const { data } = await API.createRole(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateRole = createAsyncThunk("role/updateRole", async (param, { rejectWithValue }) => {
  const { id, values } = param;
  const { name, permissions, isActive } = values;
  try {
    const body = JSON.stringify({ name, permissions, isActive });
    const { data } = await API.updateRole(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("role/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// handle search
export const loadOptionsRolePermission = createAsyncThunk(
  "role/loadOptionsRolePermission",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.loadOptionsRolePermission(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
